module.exports = __webpack_public_path__ + "img/global-alumni.15c6efd8.png";